var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21676 18.3337C9.58279 18.3337 9.8722 18.1706 10.0765 17.8531L18.1206 5.08302C18.2738 4.83415 18.3334 4.64534 18.3334 4.44796C18.3334 3.97594 18.027 3.66699 17.5588 3.66699C17.2183 3.66699 17.031 3.77856 16.8267 4.10468L9.18271 16.3855L5.21598 11.1505C5.00318 10.8501 4.79037 10.73 4.48393 10.73C3.99873 10.73 3.66675 11.0647 3.66675 11.5367C3.66675 11.7341 3.75187 11.9572 3.9136 12.1632L8.33148 17.8359C8.58685 18.1706 8.85073 18.3337 9.21676 18.3337Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckLine);
export default __webpack_public_path__ + "static/media/CheckLine.3fd2c139fff92df2fc25e779a7b7b3c5.svg";
export { ForwardRef as ReactComponent };